import { render, staticRenderFns } from "./externalCourse-settings-educators.vue?vue&type=template&id=386916db&"
import script from "./externalCourse-settings-educators.vue?vue&type=script&lang=ts&"
export * from "./externalCourse-settings-educators.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports